module.exports = __webpack_public_path__ + "img/worlds.257c618d.jpg";